export const currencyValueDivider = 100; // to convert cents to dollars
